<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="md:flex md:flex-shrink-0 noprint">
          <div class="flex items-center justify-between px-6 py-4 bg-indigo-50 md:flex-shrink-0 md:justify-center md:w-40">
            <Link class="mt-1" href="/">
              <logo class="fill-white" width="120" height="28" />
            </Link>
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <svg class="w-6 h-6 fill-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
              </template>
              <template #dropdown>
                <div class="mt-2 px-2 py-2 rounded shadow-lg mobilemenu">
                  <!-- MOBILE MENU -->
                  <main-menu :role='this.getRole()' />
                </div>
              </template>
            </dropdown>
          </div>
          <div class="md:text-md flex items-center justify-between p-4 w-full text-sm bg-white border-b md:px-6 md:py-0">
            <div class="mr-4 mt-1">
              <img v-bind:src="logourl" style="max-width:150px;" />
              <!--<span>{{ auth.user.account.name }}</span>-->
            </div>
            <div class="bg-white rounded-md shadow overflow-x-auto sm:full">
              <select class="p-2 w-full" id="jobsiteselector" @change="this.pickjobsite($event.target.value)"><option value=''>--Select a Jobsite--</option><option v-for="jobsite in filteredjobsites" :value="jobsite.id">{{jobsite.sitename}}</option></select>
            </div>
            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <div class="group flex items-center cursor-pointer select-none">
                  <div class="mr-1 text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 whitespace-nowrap">
                    <div class="w-full hidden md:inline text-right">
                      {{ auth.user.first_name }} {{ auth.user.last_name }} <img class="w-6 inline mr-0 mb-1 rounded opacity-60" :src="`https://www.gravatar.com/avatar/${auth.user.emailhash}?d=retro`" />
                    </div>
                    <br/>
                    <div class="w-full hidden md:inline text-right">
                      {{ auth.user.account.name }} - {{ auth.user.role}}
                    </div>
                  </div>
                  <icon class="w-5 h-5 fill-gray-700 group-hover:fill-indigo-600 focus:fill-indigo-600" name="cheveron-down" />
                </div>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <!--<Link class="block px-6 py-2 hover:text-white hover:bg-indigo-500" :href="`/users/${auth.user.id}/edit`">My Profile</Link>-->
                  <!--<Link v-show="auth.user.role == 'ADMIN'" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" href="/users">Manage Users</Link>-->
                  <Link class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" href="/logout" method="delete" as="button">Logout</Link>
                </div>
              </template>
            </dropdown>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <main-menu class="hidden flex-shrink-0 p-6 w-40 bg-indigo-800 overflow-y-auto md:block" :role='this.getRole()' />
          <div class="px-4 py-4 md:flex-1 md:p-6 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
#jobsiteselector {
   font-size: 16px;
  border-radius: 5px;
  border:3px solid #13B7E0;
  height: 46px;
  color: #13B7E0;
  font-weight: bold;
  min-width:200px;
  }
</style>
<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
  },
  props: {
    auth: Object,
    jobsites: Object,
  },
  methods: {
    getRole() {
      var arole = this.auth.user.role;
      return arole;
    },
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    authjobsites() {
      var jsa = JSON.parse(this.auth.user.jobsiteaccess);
      var jobsitesyes = [];
      if (this.jobsites) {
        this.jobsites.data.forEach((js) => {
          if (jsa[js.id] == 1) {
            jobsitesyes.push(js);
          }
        });
      }
        return jobsitesyes;
    },
    readCookieJobsite() {
        try {
          if (parseInt(document.cookie.split('jobsite=')[1].split(';')[0].split(' ')[0]) > 0) {
            document.querySelector('#jobsiteselector').value = parseInt(document.cookie.split('jobsite=')[1].split(';')[0].split(' ')[0]);
            document.querySelector('#updatejobsite').click(); 
          }
        } catch(e) { }
    }
  },
  data() {
    return {
      logourl: '/CM-logo-cropped-revised2.png',
      filteredjobsites: this.authjobsites(),
    };
  },
  mounted() {
    this.readCookieJobsite();
  }
}
</script>
